export default __webpack_public_path__ + "static/media/unum_sponsor_logo.2279f320.png";